<template>
    <div class="post-notes">
        <async-items-loader :task="task" :num-items="notes.length" class="q-mb-md">
            This post has no notes.
        </async-items-loader>
        <add-post-note :post-id="postId" class="q-mb-md" outlined @added="add" />
        <div v-show="notes.length" class="q-px-md q-mb-md shadow-1 radius">
            <div v-for="note in notes" :key="note.id" class="post-notes__note q-py-md">
                <div class="flex items-center">
                    <q-icon name="fa fa-user-circle"/>
                    <strong v-if="note.user" class="on-right">
                        {{ note.user.firstName }} {{ note.user.lastName }}
                    </strong>
                    <q-space />
                    <humanize-time :time="note.addedAt" class="text-grey-8" />
                </div>
                <p>{{ note.content }}</p>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
@import '../../../styles/quasar.variables';

.post-notes {
    &__note {
        border-bottom: 1px solid $grey-4;
        &:last-child {
            border-bottom: none;
        }
        p {
            margin-top: 1rem;
            margin-bottom: 0;
        }
    }
}
</style>

<script lang="ts">
import { defineComponent } from 'vue';
import { PostNote } from '@/type';
import AsyncItemsLoader from '@/components/item/AsyncItemsLoader.vue';
import HumanizeTime from '@/components/HumanizeTime.vue';
import repository from './post-notes-repository';
import AddPostNote from './AddPostNote.vue';

interface Data {
  task: Promise<PostNote[]>|null,
  notes: PostNote[]
}

export default defineComponent({
  components: { HumanizeTime, AsyncItemsLoader, AddPostNote },
  props: {
    postId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
      notes: [],
    };
  },
  watch: {
    postId: {
      handler() {
        this.load();
      },
      immediate: true,
    },
  },
  methods: {
    load() {
      this.task = repository.findAll(this.postId);
      this.task.then((notes: PostNote[]) => {
        this.notes = notes;
      });
    },
    add(note: PostNote) {
      this.notes.push(note);
    },
  },
});
</script>
